import { getManatalCountryNames } from '../utils/countryUtils';

export default function CountriesComponent({ includeValue }) {
    const countries = getManatalCountryNames();
    const hasExtra =
        includeValue &&
        includeValue !== '0' &&
        includeValue !== 0 &&
        !countries.includes(includeValue);

    return (
        <>
            {hasExtra && (
                <option value={includeValue}>{includeValue}</option>
            )}
            {countries.map((country) => (
                <option key={country} value={country}>
                    {country}
                </option>
            ))}
        </>
    );
}
